import axios from "axios";
import { API_BASE_URL } from "../utils/apiConfig";

// Single axios instance for the whole app.
// withCredentials sends the session cookie (.code-pro.app) with every request.
const axiosClient = axios.create({
    baseURL: API_BASE_URL,
    withCredentials: true
});

export default axiosClient;